import { render } from "./Dicos.vue?vue&type=template&id=3fbc1fda&scoped=true"
import script from "./Dicos.vue?vue&type=script&lang=js"
export * from "./Dicos.vue?vue&type=script&lang=js"

import "./Dicos.vue?vue&type=style&index=0&id=3fbc1fda&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbc1fda"]])

export default __exports__